//Name: Complexion
//CODE: CPLX
//Age: ''
//Gender: Both
const complexionOptions =[
  { id: '1', name: "Fair" },
  { id: '2', name: "Olive" },
  { id: '3', name: "Dark"}
];

export default complexionOptions;




// WEBPACK FOOTER //
// ./src/data/complexions.js